import { foldInstallableAppIdentifier } from '../../../records/InstallableAppIdentifier';
import { MARKETPLACE_APP_KEY } from '../types';
export const getAppKeyFromInstallableAppIdentifier = installableAppIdentifier => foldInstallableAppIdentifier(installableAppIdentifier)(key => key.key, url => url.key, ari => ari.appKey);
export const getAppKeyFromInstallIdentifier = installIdentifier => {
  if (installIdentifier === null) {
    return;
  }
  if (installIdentifier.type === MARKETPLACE_APP_KEY) {
    return installIdentifier.keyForInstall;
  }
  return getAppKeyFromInstallableAppIdentifier(installIdentifier.keyForInstall);
};